const mergeOperations = rawOperations => {
  return rawOperations.reduce( (merged, page) => [...merged, ...page], []);
};

export const parseAllOperations = ( rawOperations ) => {
  // because it may be one or many operations, it may or may not be an array of paged results
  if( !Array.isArray(rawOperations[0]) ) {
    rawOperations = [ rawOperations ];
  }
  const mergedRawOperations = mergeOperations(rawOperations);
  return mergedRawOperations.reduce( (parsed, operation) => {
    parsed[operation.operationId] = operation;
    return parsed;
  }, {});
};
